
import React, { useState } from "react";
import SidebarGalleryPage from "../Main/Sidebargallery";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import cb_banner from "../../assets/Feedback/cb_banner.jpg";

// Scholarship Data
const scholarshipData = [
  {
    title: "Details of Scholarship Schemes",
    content: [
      "Vikramaditya Yojna",
      "Chhatra Griha Yojna for OBC Students",
      "Disabled Scholarship Application Form",
      "Mukhyamantri Medhavi Vidyarthi Yojana",
    ],
  },
  {
    title: "Links for Scholarship Schemes",
    content: [
      {
        label: "Govt. of M.P. Website",
        link: "http://scholarshipportal.mp.nic.in/",
      },
      {
        label: "Post Matric Scholarships (India)",
        link: "http://momascholarship.gov.in/",
      },
    ],
  },
  {
    title: "Online Scholarship Applications",
    content: [
      {
        label: "AICTE Pragati and Saksham Scholarship Scheme",
        link: "path_to_your_pdf.pdf",
      },
    ],
  },
];

const Scholarships = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleDropdown = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="flex justify-center items-center bg-gray-100 min-h-screen p-12">
      <div className="flex flex-col lg:flex-row lg:gap-5 w-full max-w-7xl">
        {/* Left Side */}
        <motion.div
          className="w-full lg:w-[70%] "
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Main Image */}
          <motion.img
            src={cb_banner}
            alt="Scholarships Banner"
            className="w-full shadow-md p-2 border-4 border-teal-500 rounded-lg"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8 }}
          />

          {/* Scholarship Information */}
          <div className="border-4 border-teal-500 rounded-lg p-4 mt-10 mb-10">
              <div className="space-y-4">
                <h2 className="text-2xl ml-2 font-bold flex items-center gap-2 text-teal-500 ">
                  Scholarship Opportunities
                </h2>
              </div>

              {/* Dropdown Section */}
              {scholarshipData.map((section, index) => (
                <div key={index}>
                  <button
                    onClick={() => toggleDropdown(index)}
                    className="w-full bg-teal-500 text-white text-lg font-semibold py-3 px-4 rounded-lg flex justify-between items-center mt-5"
                  >
                    {section.title}
                    <span className="text-xl">&#9660;</span>
                  </button>
                  {openIndex === index && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5 }}
                      className="mt-2 p-3 rounded-lg text-gray-600 space-y-2"
                    >
                      {section.content.map((item, idx) => (
                        <p key={idx}>
                          {item.label ? (
                            <strong>{item.label}:</strong>
                          ) : (
                            <span>{item}</span>
                          )}
                          {item.link && (
                            <a
                              href={item.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 underline break-words"
                            >
                              {item.link}
                            </a>
                          )}
                        </p>
                      ))}
                    </motion.div>
                  )}
                </div>
              ))}
          </div>  
        </motion.div>

        {/* Right Side - Slider */}
        <SidebarGalleryPage />
      </div>
    </div>
  );
};

export default Scholarships;
